import { memo, useCallback } from 'react'
import ReviewCard from './ReviewCard'

/**
 * ReviewList - Paginated list of ReviewCard items
 * @idempotent @atomic
 */
const ReviewList = memo(function ReviewList({
  reviews, hasMore, loading, onLoadMore,
  currentUserId, isAdmin, onEdit, onDelete, t
}) {
  const handleLoadMore = useCallback((e) => {
    e.preventDefault()
    onLoadMore?.()
  }, [onLoadMore])

  if (!loading && reviews.length === 0) {
    return (
      <p className="text-xs text-gray-500 italic py-2">
        {t('review.noReviews', 'No reviews yet. Be the first to share your experience!')}
      </p>
    )
  }

  return (
    <div>
      {reviews.map(review => (
        <ReviewCard
          key={review.id}
          review={review}
          currentUserId={currentUserId}
          isAdmin={isAdmin}
          onEdit={onEdit}
          onDelete={onDelete}
          t={t}
        />
      ))}
      {hasMore && (
        <button
          type="button"
          onClick={handleLoadMore}
          onTouchEnd={handleLoadMore}
          disabled={loading}
          className="w-full mt-2 py-1.5 text-xs font-medium text-primary hover:text-primary/80 disabled:opacity-50 transition-colors"
        >
          {loading
            ? t('common.loading', 'Loading...')
            : t('review.loadMore', 'Load more reviews')
          }
        </button>
      )}
    </div>
  )
})

export default ReviewList
